import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

DateInput.propTypes = {
  inputRef: PropTypes.any,
  onChange: PropTypes.func,
  name: PropTypes.string,
  dateFormat: PropTypes.string,
};
export default function DateInput(props) {
  const { inputRef, onChange, name, dateFormat, ...rest } = props;

  const isMonthYear = dateFormat === 'MM/YYYY';
  const format = isMonthYear ? '##/####' : '##/##/####';
  const placeholder = isMonthYear ? 'MM/YYYY' : 'MM/DD/YYYY';
  const mask = isMonthYear ? ['M', 'M', 'Y', 'Y', 'Y', 'Y'] : ['M', 'M', 'D', 'D', 'Y', 'Y', 'Y', 'Y'];

  return (
    <NumberFormat
      {...rest}
      name={name}
      getInputRef={inputRef}
      displayType={'input'}
      type={'text'}
      format={format}
      placeholder={placeholder}
      mask={mask}
      onValueChange={(values) => {
        onChange({
          target: {
            name,
            value: values.formattedValue,
          },
        });
      }}
    />
  );
}
